let fieldrequired = {
  test: value => {
    return value !== ''
  },
  message: 'Field required'
};
let maxLengthisthree =
{
  test: value => {
    return (value || '').length <= 3
  },
  message: 'Max length is 3'
};

export const idOptionsvvValidation = [
  {description: "US_IRS_ID",ediCode: "US_IRS_ID",id: "US_IRS_ID",formatDescription:'NN-NNNNNNNXX',formatRegex:'^[0-9]{2}\-[0-9]{7}([ ]{0,2}|[a-zA-Z0-9]{2})$'},
  {description: "US_CBP_ID",ediCode: "US_CBP_ID",id: "US_CBP_ID",formatDescription:'YYDDPP-NNNNN',formatRegex:'^[0-9]{6}\-[0-9]{5}$'},
  {description: "US_SSN",ediCode: "US_SSN",id: "US_SSN",formatDescription:'NNN-NN-NNNN',formatRegex:'^[0-9]{3}\-[0-9]{2}\-[0-9]{4}$'}
];

export const importerFields = {
  importerFullName: {
    label: 'Full Number',
    apiKey: 'importerFullName',
    rules: [],
    errors: [],
    valid: true
  },
  importerAddress: {
    label: 'Address',
    apiKey: 'importerAddress',
    rules: [],
    errors: [],
    valid: true
  },
  importerCity: {
    label: 'City',
    apiKey: 'importerCity',
    rules: [],
    errors: [],
    valid: true
  },
  importerState: {
    label: 'State/Province/Region',
    apiKey: 'importerState',
    rules: [maxLengthisthree],
    errors: [],
    valid: true
  },
  importerZip: {
    label: 'Zip',
    apiKey: 'importerZip',
    rules: [],
    errors: [],
    valid: true
  },
  importerCountry: {
    label: 'Country',
    apiKey: 'importerCountry',
    rules: [],
    errors: [],
    valid: true
  },
  consigneeFullName: {
    label: 'Full Number',
    apiKey: 'importerFullName',
    rules: [],
    errors: [],
    valid: true
  },
  consigneeAddress: {
    label: 'Address',
    apiKey: 'importerAddress',
    rules: [],
    errors: [],
    valid: true
  },
  consigneeCity: {
    label: 'City',
    apiKey: 'importerCity',
    rules: [],
    errors: [],
    valid: true
  },
  consigneeState: {
    label: 'State/Province/Region',
    apiKey: 'importerState',
    rules: [maxLengthisthree],
    errors: [],
    valid: true
  },
  consigneeZip: {
    label: 'Zip',
    apiKey: 'importerZip',
    rules: [],
    errors: [],
    valid: true
  },
  consigneeCountry: {
    label: 'Country',
    apiKey: 'importerCountry',
    rules: [],
    errors: [],
    valid: true
  },
  SHIP_TOFullName: {
    label: 'Full Number',
    apiKey: 'importerFullName',
    rules: [],
    errors: [],
    valid: true
  },
  SHIP_TOAddress: {
    label: 'Address',
    apiKey: 'importerAddress',
    rules: [],
    errors: [],
    valid: true
  },
  SHIP_TOCity: {
    label: 'City',
    apiKey: 'importerCity',
    rules: [],
    errors: [],
    valid: true
  },
  SHIP_TOState: {
    label: 'State/Province/Region',
    apiKey: 'importerState',
    rules: [maxLengthisthree],
    errors: [],
    valid: true
  },
  SHIP_TOZip: {
    label: 'Zip',
    apiKey: 'importerZip',
    rules: [],
    errors: [],
    valid: true
  },
  SHIP_TOCountry: {
    label: 'Country',
    apiKey: 'importerCountry',
    rules: [],
    errors: [],
    valid: true
  },
  CONSOLIDATORFullName: {
    label: 'Full Number',
    apiKey: 'importerFullName',
    rules: [],
    errors: [],
    valid: true
  },
  CONSOLIDATORAddress: {
    label: 'Address',
    apiKey: 'importerAddress',
    rules: [],
    errors: [],
    valid: true
  },
  CONSOLIDATORCity: {
    label: 'City',
    apiKey: 'importerCity',
    rules: [],
    errors: [],
    valid: true
  },
  CONSOLIDATORState: {
    label: 'State/Province/Region',
    apiKey: 'importerState',
    rules: [maxLengthisthree],
    errors: [],
    valid: true
  },
  CONSOLIDATORZip: {
    label: 'Zip',
    apiKey: 'importerZip',
    rules: [],
    errors: [],
    valid: true
  },
  CONSOLIDATORCountry: {
    label: 'Country',
    apiKey: 'importerCountry',
    rules: [],
    errors: [],
    valid: true
  },
  MANUFACTURERFullName: {
    label: 'Full Number',
    apiKey: 'importerFullName',
    rules: [],
    errors: [],
    valid: true
  },
  MANUFACTURERAddress: {
    label: 'Address',
    apiKey: 'importerAddress',
    rules: [],
    errors: [],
    valid: true
  },
  MANUFACTURERCity: {
    label: 'City',
    apiKey: 'importerCity',
    rules: [],
    errors: [],
    valid: true
  },
  MANUFACTURERState: {
    label: 'State/Province/Region',
    apiKey: 'importerState',
    rules: [maxLengthisthree],
    errors: [],
    valid: true
  },
  MANUFACTURERZip: {
    label: 'Zip',
    apiKey: 'importerZip',
    rules: [],
    errors: [],
    valid: true
  },
  MANUFACTURERCountry: {
    label: 'Country',
    apiKey: 'importerCountry',
    rules: [],
    errors: [],
    valid: true
  },
  STUFFERFullName: {
    label: 'Full Number',
    apiKey: 'importerFullName',
    rules: [],
    errors: [],
    valid: true
  },
  STUFFERAddress: {
    label: 'Address',
    apiKey: 'importerAddress',
    rules: [],
    errors: [],
    valid: true
  },
  STUFFERCity: {
    label: 'City',
    apiKey: 'importerCity',
    rules: [],
    errors: [],
    valid: true
  },
  STUFFERState: {
    label: 'State/Province/Region',
    apiKey: 'importerState',
    rules: [maxLengthisthree],
    errors: [],
    valid: true
  },
  STUFFERZip: {
    label: 'Zip',
    apiKey: 'importerZip',
    rules: [],
    errors: [],
    valid: true
  },
  STUFFERCountry: {
    label: 'Country',
    apiKey: 'importerCountry',
    rules: [],
    errors: [],
    valid: true
  },
  BUYERFullName: {
    label: 'Full Number',
    apiKey: 'importerFullName',
    rules: [],
    errors: [],
    valid: true
  },
  BUYERAddress: {
    label: 'Address',
    apiKey: 'importerAddress',
    rules: [],
    errors: [],
    valid: true
  },
  BUYERCity: {
    label: 'City',
    apiKey: 'importerCity',
    rules: [],
    errors: [],
    valid: true
  },
  BUYERState: {
    label: 'State/Province/Region',
    apiKey: 'importerState',
    rules: [maxLengthisthree],
    errors: [],
    valid: true
  },
  BUYERZip: {
    label: 'Zip',
    apiKey: 'importerZip',
    rules: [],
    errors: [],
    valid: true
  },
  BUYERCountry: {
    label: 'Country',
    apiKey: 'importerCountry',
    rules: [],
    errors: [],
    valid: true
  },
  SELLERFullName: {
    label: 'Full Number',
    apiKey: 'importerFullName',
    rules: [],
    errors: [],
    valid: true
  },
  SELLERAddress: {
    label: 'Address',
    apiKey: 'importerAddress',
    rules: [],
    errors: [],
    valid: true
  },
  SELLERCity: {
    label: 'City',
    apiKey: 'importerCity',
    rules: [],
    errors: [],
    valid: true
  },
  SELLERState: {
    label: 'State/Province/Region',
    apiKey: 'importerState',
    rules: [maxLengthisthree],
    errors: [],
    valid: true
  },
  SELLERZip: {
    label: 'Zip',
    apiKey: 'importerZip',
    rules: [],
    errors: [],
    valid: true
  },
  SELLERCountry: {
    label: 'Country',
    apiKey: 'importerCountry',
    rules: [],
    errors: [],
    valid: true
  }
}
